import React from 'react';
import PropTypes from 'prop-types';

import { SubscriptionCardSection } from './section';
import { emptyArray } from 'ui-components/default-props/empty';
import { filterLineItemsByFeatureUniqueness } from '../../components/manage-subscription-drawer/helpers';
import messages from './messages';
import { useBuildAddOnFeatures } from '../../../../../hooks/add-ons/use-build-addons';
import { useGetSubscriptionCurrencyCode } from '../../hooks/use-get-subscription-currency-code';
import { useIsSellerOnFeatureGatedPlan } from '../../../../../feature-gates/use-is-seller-on-feature-gated-plan';

export const SubscriptionCardAddOnsAndFeatures = ({ lineItems = emptyArray }) => {
  const addOnFeaturesReferences = useBuildAddOnFeatures();
  const billignCurrencyCode = useGetSubscriptionCurrencyCode();
  const isNewLineupEnabled = useIsSellerOnFeatureGatedPlan();
  const lineItemsToDisplay = filterLineItemsByFeatureUniqueness(
    lineItems,
    addOnFeaturesReferences,
    billignCurrencyCode,
    isNewLineupEnabled,
  );

  if (lineItemsToDisplay.length > 0) {
    return <SubscriptionCardSection lineItems={lineItemsToDisplay} title={messages.addOnsAndFeatures} />;
  }
};

SubscriptionCardAddOnsAndFeatures.propTypes = {
  lineItems: PropTypes.array,
};
